import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import { FeatureItem, FeatureItemProps } from './FeatureItem'
import { useSelector } from 'src/hooks'

type FeatureColumn = {
  title?: string
  features: FeatureItemProps[]
}

type FeatureChartProps = {
  columns: FeatureColumn[] // two columns, ideally
}

export const FeatureItemChart: FC<FeatureChartProps> = ({ columns }) => {
  const windowWidth = useSelector(state => state.window.width)
  const isMobile = windowWidth <= 1000

  return (
    <Flex
      flexDirection={isMobile ? 'column' : 'row'}
      flexWrap={isMobile ? 'wrap' : 'nowrap'}
      justifyContent={isMobile ? 'center' : 'space-between'}
      alignItems="stretch"
      inset={{ horizontal: 'x2_5', vertical: 'x3' }}
      backgroundColor="rgba(184, 184, 184, 0.14)"
      borderRadius="medium"
      columnGap="x1"
      maxWidth="1300px"
    >
      {columns.map((col, colIndex) => (
        <Flex
          key={colIndex}
          width={isMobile ? '100%' : '50%'}
          flexDirection="column"
        >
          {col.title && (
            <Text
              inset={{ left: '12px' }}
              type="title"
              style={{ fontSize: '14px', marginBottom: '8px' }}
            >
              {col.title}
            </Text>
          )}
          {col.features.map((feature, i) => (
            <FeatureItem key={i} {...feature} />
          ))}
        </Flex>
      ))}
    </Flex>
  )
}
